export default "__VITE_ASSET__ECb6eKyn__"